import type { PurePmInEditorDirectStreamingPluginState } from './types';

/**
 * Creates fresh initial state
 */
export function createInitialState(): PurePmInEditorDirectStreamingPluginState {
	return {
		// Original fields
		showHighlight: false,
		showAIContentHighlight: false,
		showTelepointer: false,
		isStreaming: false,
		isStreamingFinished: false,
		startPos: undefined,
		loadingPos: undefined,
		userContentEndPos: undefined,
		aiContentEndPos: undefined,
		telepointerPos: undefined,
		isFinalStream: false,
		chunkNumber: 0,
		streamTimeStamp: undefined,

		// New fields
		streamPhase: 'idle',
		// Use -1 so that responseVersion 0 > -1 triggers the first update
		// This is important for subsequent streams in the same session where
		// responseVersion resets to 0
		lastProcessedVersion: -1,
		posAdjusted: false,
		hasFinalStream: false,
		originalUserContentSlice: undefined,
		reviewOriginalSlice: undefined,
		aiContentSlice: undefined,
		scrollTargetPos: undefined,
		isPaused: true,
		isQuickAction: false,
		streamStartPos: undefined,
		currentSessionId: undefined,
	};
}
